import { DisconnectOutlined } from '@ant-design/icons'
import { $getNodeByKey } from 'lexical'

import { pick } from '@eastcoal/common/utils/object'

import { useEditor } from '../../../../hooks/useEditor'
import { $isLinkNode } from '../../../../nodes/LinkNode/index'
import { TOGGLE_LINK_COMMAND } from '../../../../plugins/LinkPlugin/commands'
import { MenuButton } from '../../../MenuButton'
import { useLinkCardStore } from '../../Store/hooks/useStore'

export const CancelLinkButton = () => {
  const editor = useEditor()

  const { nodeKey, toggleToolbarVisible } = useLinkCardStore(state =>
    pick(state, ['nodeKey', 'toggleToolbarVisible'])
  )

  const handleRemoveLink = () => {
    toggleToolbarVisible(false)
    editor.update(() => {
      const node = $getNodeByKey(nodeKey)
      if ($isLinkNode(node)) {
        node.select()
        editor.dispatchCommand(TOGGLE_LINK_COMMAND, false)
      }
    })
  }

  return (
    <MenuButton tooltip='取消链接' onClick={handleRemoveLink}>
      <DisconnectOutlined />
    </MenuButton>
  )
}
